// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oMjM","content":"styles_content__31jQJ","tableWrap":"styles_tableWrap__-He8L"};